import type { CSSProperties } from "react";
import { tokens } from "../tokens";

interface SkeletonProps {
	width?: number | string;
	height?: number | string;
	radius?: number;
	style?: CSSProperties;
}

// A loading placeholder in the shape of the content it stands in for, not a spinner. It is a surface
// step that breathes; the layout it occupies is the layout the content will occupy.
export function Skeleton({ width = "100%", height = tokens.space.lg, radius = tokens.radius.sm, style }: SkeletonProps) {
	return (
		<span
			aria-hidden="true"
			style={{
				display: "block",
				width,
				height,
				borderRadius: radius,
				background: tokens.color.surface.raisedStrong,
				animation: `mm-skeleton ${tokens.motion.breath}ms ${tokens.motion.easing} infinite`,
				...style,
			}}
		/>
	);
}
